module.exports = __webpack_public_path__ + "assets/img/sm3.d639508a.png";